import { Job } from '@quizdb/common';

/** `text` cut to `max` characters, with an ellipsis when it was cut (QZ-D47). */
export const truncate = (text: string, max: number): string =>
  text.length <= max ? text : `${text.slice(0, max)}…`;

/**
 * A job's displayed title (PDG-D10): its plan's title once set, else its request, else its
 * study material's file name for an untitled material job, cut to `max` characters.
 */
export const jobDisplayTitle = (job: Job, max: number): string =>
  truncate(job.title ?? job.request ?? job.studyMaterial?.name ?? '', max);

/**
 * The icon a job is shown with: a file for a PDF job, stacked pictures for a photo job, a
 * message bubble for a prompt (PDG-D10, QZ-D91). A `switch` with no default, so a method added
 * without an icon fails to compile here.
 */
export const jobIcon = (job: Job): 'file-pdf' | 'images' | 'message' => {
  switch (job.method) {
    case 'pdf':
      return 'file-pdf';
    case 'photos':
      return 'images';
    case 'prompt':
      return 'message';
  }
};

/** The chunks' planned task counts, summed (QZ-D73, QZ-D162). */
export const plannedCount = (job: Job): number =>
  job.chunks.reduce((total, chunk) => total + chunk.taskCount, 0);
